import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "app/app-state.index";
import { setDisplayLoginDialog } from "app/shared/state/actions/‏‏shared-common.action";
import { DialogService } from "primeng/dynamicdialog";
import { LoginComponent } from "../components/login/login.component";
@Injectable()
export class LoginService {

    constructor(private dialogService: DialogService, private store: Store<AppState>,private httpClient: HttpClient) {

    }
    showLoginDialog(cdr?: ChangeDetectorRef) {
        this.store.dispatch(setDisplayLoginDialog({ displayLoginDialog: true }));
    }

    closeLoginDialog() {
        this.store.dispatch(setDisplayLoginDialog({ displayLoginDialog: false }));

    }
    AgreementUrl(language) {
        return this.httpClient.post(`/webroulette/agreementUrl`, { language});
    }
    getCategoriesTypes (language){
        return this.httpClient.post(`/common/getCategoriesTypes`,{language})
    }
    sendVerificationCode(email: string,currentLang:string) {
        const requestSendCode = { Email: email,Language:currentLang };
        return this.httpClient.post<{Success: boolean,Status:number}>(`/auth/sendVerificationCode`, requestSendCode)
    }
    verifyCode(email:string,code:string){
        const requestSendCode = { Email: email,Code:code };
        return this.httpClient.post<{Success: boolean,Status:number,Token:string}>('/auth/VerifyCode',requestSendCode);
    }
    changePassword(email:string,password:string,token:string){
      const changePasswordRequest={Email:email,Password:password,Token:token}  
      return this.httpClient.post<{ message: string}>('/auth/ChangePasswordAfterForget',changePasswordRequest)
    }
    
}